import { combineReducers } from "redux"

import customer from "../actions/CustomerActions";
import customerConfig from "../actions/ListActions";
import invoice from "../actions/InvoiceActions";
import messages from "../actions/PageModule";
import offer from '../actions/OfferActions';
import subscription from '../actions/SubscriptionActions';
import user from "../actions/UserActions";
import terminationReason from "../actions/TerminationReasonsActions";
import payment from "../actions/PaymentActions";
import billingAccount from "../actions/BillingAccountActions";
import provider from "../actions/ProviderActions";
import account from "../actions/UserAccountActions";
export default combineReducers({
  customer,
  customerConfig,
  invoice,
  messages,
  offer,
  subscription,
  user,
  terminationReason,
  payment,
  billingAccount,
  provider,
  account
})



// WEBPACK FOOTER //
// ./src/opencell/services/index.js